import { render, staticRenderFns } from "./SendDialog.vue?vue&type=template&id=8c015be4&scoped=true&"
import script from "./SendDialog.vue?vue&type=script&lang=js&"
export * from "./SendDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendDialog.vue?vue&type=style&index=0&id=8c015be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c015be4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VSpacer,VTextarea})
